import { Controller } from '@hotwired/stimulus';
import { withProfiler } from '@sentry/react';
import { Root, createRoot } from 'react-dom/client';

import RetailApp, { createRouter } from '../../apps/RetailApp';

const RetailAppWithProfiler = withProfiler(RetailApp, { name: 'RetailApp' });

export default class extends Controller {
  root?: Root;

  connect() {
    const router = createRouter();

    this.root ??= createRoot(this.element);
    this.root.render(<RetailAppWithProfiler router={router} />);
  }

  disconnect() {
    this.root?.unmount();
    this.root = undefined;
  }
}
